/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { membershipUpdateRestRequestSchema } from './membershipUpdateRestRequestSchema';

export const membershipUpdateItemSchema = z.object({
  membershipId: z.int(),
  get update() {
    return membershipUpdateRestRequestSchema;
  },
});
